import { render, staticRenderFns } from "./CreateCorreo.vue?vue&type=template&id=07d7ef37&scoped=true&"
import script from "./CreateCorreo.vue?vue&type=script&lang=js&"
export * from "./CreateCorreo.vue?vue&type=script&lang=js&"
import style0 from "./CreateCorreo.vue?vue&type=style&index=0&id=07d7ef37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d7ef37",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCol,VForm,VRadio,VRadioGroup,VRow,VTextField})
